import type { HttpProgressEvent, HttpResponse } from '@angular/common/http';
import type { FileWebServiceInterface } from '@commons/bo-ui/form/file-picker/services/file.web-service.interface';
import type { AdditionalPermissions } from '@loyalty/utils-angular/webservices';
import type { Observable } from 'rxjs';

import { HttpEventType } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { FileWebservice as FileApiWebservice } from '@loyalty/utils-angular/webservices';
import { WizFile } from '@loyalty/utils/models';
import { concat } from 'rxjs';
import { distinct, filter, map, shareReplay } from 'rxjs/operators';

@Injectable()
export class FileWebService implements FileWebServiceInterface {
  readonly #fileApiWebservice = inject(FileApiWebservice);

  get(fileId: string): Observable<Blob> {
    return this.#fileApiWebservice.getDownloadBlob(fileId);
  }

  post(domFile: Blob, isPublic = true, additionalPermissions?: AdditionalPermissions): Observable<number | string> {
    const wizFile = new WizFile({ domFile });
    const result$ = this.#fileApiWebservice.create(wizFile, isPublic, additionalPermissions).pipe(shareReplay(1));

    const url$ = result$.pipe(
      filter((event) => event.type === HttpEventType.Response),
      map((event) => event as HttpResponse<{ id: string }>),
      map((event) => event.body!.id)
    );

    const progress$ = result$.pipe(
      filter((event) => event.type === HttpEventType.UploadProgress),
      map((event) => event as HttpProgressEvent),
      map((event) => event.loaded / event.total!),
      map((progress) => Math.ceil(progress * 10000) / 100),
      distinct()
    );

    return concat(progress$, url$);
  }

  getFileUrl(fileId: string): Observable<string> {
    return this.#fileApiWebservice.getFileUrl(fileId);
  }
}
